import { toolSelection } from '../../app-connection/types'
import { locale } from '../../user/locale'
import { z } from 'zod'
import { configuration } from '../../public-form/public-form'
import { agentType, CUSTOM_AGENT, INTERVIEW_AGENT, SALES_AGENT } from '../agent-type'

export const question = z.object({
    text: z.string(),
    autoReject: z.boolean(),
})

export const clarificationDepth = z.enum(['none', 'once', 'twice', 'until_answered'])
// t('clarificationDepth.none')
// t('clarificationDepth.none.help')
// t('clarificationDepth.once')
// t('clarificationDepth.once.help')
// t('clarificationDepth.twice')
// t('clarificationDepth.twice.help')
// t('clarificationDepth.until_answered')
// t('clarificationDepth.until_answered.help')

export const interviewCampaignData = z.object({
    vacancy: z.string(),
    feedback: z.string().nullable().optional(),
    questions: question.array(),
    clarificationDepth: clarificationDepth.optional(),
})

export const promptCampaignData = z.object({
    prompt: z.string().nullable().optional(),
})

const storeInputBase = z.object({
    publicFormEnabled: z.boolean().optional(),
    publicForm: configuration.optional(),
    locale: locale.optional(),
    allowLanguageSwitch: z.boolean().optional(),
    title: z.string(),
    accountId: z.string().optional().nullable(),
    formId: z.string().optional().nullable(),
    whatsappBusinessAccountId: z.string().optional().nullable(),
    phoneNumberId: z.string().optional().nullable(),
    startMessageTemplateId: z.string().optional().nullable(),
    recontactSchedule: z
        .array(
            z.object({
                messageTemplateId: z.string(),
                delayMinutes: z.number(),
                sortOrder: z.number(),
            })
        )
        .optional()
        .nullable(),
    recontactQuietHoursEnabled: z.boolean().optional().nullable(),
    recontactQuietHoursStart: z.string().optional().nullable(),
    recontactQuietHoursEnd: z.string().optional().nullable(),
})

export const interviewStoreInput = storeInputBase.extend({
    type: z.literal(INTERVIEW_AGENT),
    data: interviewCampaignData,
})

const promptStoreInputBase = storeInputBase.extend({
    data: promptCampaignData,
})

export const salesStoreInput = promptStoreInputBase.extend({
    type: z.literal(SALES_AGENT),
})

export const customStoreInput = promptStoreInputBase.extend({
    type: z.literal(CUSTOM_AGENT),
    tools: toolSelection.array().optional(),
})

export const storeInput = z.discriminatedUnion('type', [interviewStoreInput, customStoreInput, salesStoreInput])

export type Question = z.infer<typeof question>
export type ClarificationDepth = z.infer<typeof clarificationDepth>
export type AgentType = z.infer<typeof agentType>
export type InterviewCampaignData = z.infer<typeof interviewCampaignData>
export type PromptCampaignData = z.infer<typeof promptCampaignData>
export type StoreInput = z.infer<typeof storeInput>
